import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { useStripe, Elements } from "@stripe/react-stripe-js";
import { PAGES } from "@/config";
import { usePaymentStore } from "@/store/usePaymentStore";
import { useUserStore } from "@/store";
import { Layout, StateInfoBox } from "@/components";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  import.meta.env.VITE_REACT_APP_STRIPE_PUBLIC_KEY!,
);

const PostPaymentInner = () => {
  const stripe = useStripe();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { verifyPaymentStatus, discardPaymentIntentByToken } = usePaymentStore(
    (state) => state,
  );
  // In case to show specific message to user
  // const serverStatus = usePaymentStore(
  //   (state) => state.serverConfirmationStatus,
  // );
  const restoreIntentData = useUserStore((state) => state.restoreIntentData);

  useEffect(() => {
    const managePayment = async () => {
      if (!stripe) {
        return;
      }

      const token = searchParams.get("token");
      const clientSecret = searchParams.get("payment_intent_client_secret");

      if (!clientSecret || !token) {
        navigate(PAGES.HOME);
        return;
      }

      if (token) {
        await restoreIntentData(token);
      }

      // Retrieve the PaymentIntent
      //https://docs.stripe.com/payments/accept-a-payment?platform=web&ui=elements&client=react
      const { paymentIntent } =
        await stripe.retrievePaymentIntent(clientSecret);

      if (!paymentIntent) {
        navigate(PAGES.HOME);
        return;
      }

      switch (paymentIntent?.status) {
        case "succeeded":
        case "processing": {
          const isConfirmed = await verifyPaymentStatus(clientSecret, token);
          if (isConfirmed) {
            navigate(PAGES.AML_CHECK);
          } else {
            navigate(PAGES.ERROR_PAGE, { state: { message: 'Payment verification failed', data: { clientSecret, token } } });
          }
          break;
        }

        case "requires_payment_method":
          await discardPaymentIntentByToken(token);
          navigate(PAGES.HOME);
          break;

        default:
          await discardPaymentIntentByToken(token);
          navigate(PAGES.HOME);
          break;
      }
    };

    managePayment();
  }, [
    stripe,
    verifyPaymentStatus,
    navigate,
    restoreIntentData,
    searchParams,
    discardPaymentIntentByToken,
  ]);

  return (
    <StateInfoBox type="loading" />
  );
};

const PostPayment = () => {
  return (
    <Layout title="Checking payment status...">
      <Elements stripe={stripePromise}>
        <PostPaymentInner />
      </Elements>
    </Layout>
  );
};

export default PostPayment;
